module.exports = {
      id: "mode-circle-usage",
      viewBox: "0 0 25 25",
      url: __webpack_public_path__ + "img/icons.a7e6c507.svg#mode-circle-usage",
      toString: function () {
        return this.url;
      }
    }